export default __webpack_public_path__ + "static/media/school.6c6078e9.svg";